import { render, staticRenderFns } from "./CatalogPageElementContent.vue?vue&type=template&id=09efbbdf"
import script from "./CatalogPageElementContent.vue?vue&type=script&lang=js"
export * from "./CatalogPageElementContent.vue?vue&type=script&lang=js"
import style0 from "./CatalogPageElementContent.vue?vue&type=style&index=0&id=09efbbdf&prod&lang=css"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports